export const statusColor: { [key: string]: string } = {
  open: "rgba(210, 136, 23, 1)",
  pending: "rgba(35, 120, 204, 1)",
  inactive: "rgb(241, 0, 28)",
  completed: "rgb(79, 184, 123)",
  submitted: "rgba(35, 120, 204, 1)",
  approved: "rgb(79, 184, 123)",
  rejected: "rgb(241, 0, 28)",
  underreview: "rgba(210, 136, 23, 1)",
  credit: "rgb(79, 184, 123)",
  debit: "rgb(241, 0, 28)",
  failed: "rgb(241, 0, 28)",
};

export const defaultParams = {
  search: "",
  sortKey: "updatedAt",
  sortOrder: "DESC",
  page: 1,
  pageSize: 10,
  status: "",
};
